<!-- 人员菜单权限树 -->
<template>
	<el-dialog append-to-body title="独立授权" :modal-append-to-body="false" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="authVisible" v-if="authVisible" width= "450px">
        <authTree ref="authTree" @cancel="authVisible=false"/>
    </el-dialog>
</template>

<script>
import authTree from './authTree';

export default {
	name: "userAuth",
    components: {
        authTree
    },
	data() {
		return {
			authVisible: false,
		}
	},
	methods: {
		// 打开树事件
		open(param) {
            this.authVisible = true;
            this.$nextTick(()=>{
                this.$refs.authTree.open(param);
            })
        },
	}
}
</script>

<style lang="sass" scoped>
	
</style>